<template>
  <div class="text-right">
    <v-dialog :fullscreen="$vuetify.breakpoint.mobile" v-model="dialog" width="600">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="primary"> <v-icon left>add</v-icon>Thêm Khối </v-btn>
      </template>
      <v-card>
        <v-toolbar color="#FFB300" dense class="elevation-0" dark>
          <v-toolbar-title>Thêm Khối</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <major-form ref="majorForm"></major-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn depressed class="text-left mx-2" color="primary" @click="save">
            <v-icon class="mr-2">add</v-icon>
            <span>Lưu</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import MajorForm from '@/components/basic/form/MajorParentForm'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    MajorForm
  },
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    ...mapState('app', ['department']),
    ...mapState('auth', ['profile', 'role'])
  },
  methods: {
    ...mapActions('major', ['createMajor']),
    cancel() {
      this.$refs.majorForm.reset()
      this.dialog = false
    },
    save() {
      const data = {
        ...this.$refs.majorForm.getData(),
        department: this.department.id,
        type: 'root'
      }
      this.createMajor({ data, options: {} })
      this.dialog = false
    }
  }
}
</script>
